import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { toastEnter, toastExit } from './keyframes';
const toastListStaticStyle = css({
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: `0 ${tokens.spacingNew.medium}`,
    pointerEvents: 'none',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: tokens.zIndex.toast,
    [mediaQuery.aboveSmall]: {
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'auto',
    },
});
export function toastsListStyle({ offset }) {
    return [
        toastListStaticStyle,
        css({
            paddingTop: offset,
        }),
    ];
}
const animatedWrapperStaticStyle = css({
    listStyle: 'none',
    opacity: 0,
    transform: 'scale3d(0.5, 0.5, 0.5)',
    transformOrigin: '50% 20%',
});
export function animatedWrapperStyle({ height, isVisible, }) {
    return [
        animatedWrapperStaticStyle,
        css({
            animation: `${isVisible ? toastEnter : toastExit({ height })} 500ms ${isVisible
                ? 'cubic-bezier(0.2, 1, 0.4, 1)'
                : 'cubic-bezier(0.4, 1, 0.4, 0.8)'} forwards`,
            height,
        }),
    ];
}
export const toastStaticStyle = css({
    borderColor: theme.border.main,
    boxShadow: theme.boxShadow.thick,
    marginTop: tokens.spacingNew.medium,
    pointerEvents: 'all',
    userSelect: 'none',
    width: '100%',
    [mediaQuery.aboveSmall]: {
        width: '360px',
    },
});
export const titleStaticStyle = css({
    lineHeight: tokens.lineHeights.relaxed,
    margin: 0,
    padding: `${tokens.spacingNew.tiny} 0`,
});
export const descriptionStaticStyle = css({
    marginBottom: 0,
    marginTop: tokens.spacingNew.tiny,
});
